import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux'
import moment from 'moment'
import { browserHistory } from 'react-router'
import cookie from 'react-cookies'
import { trackPromise } from 'react-promise-tracker'

import {
  hasDiet,
  getUserDailyBalance,
  getUserDietData,
  removeSpecificMeal,
} from '../../../Api/dietApi/userInfo'

import { getUserData } from '../../../Api/backendApi'

import DietMainScreen from './DietMainScreen.tsx'

class DietMainScreenContainer extends Component {
  state = {
    userDailyBalance: [],
    date: moment().format('dddd, DD MMMM'),
    daysAdded: 0,
    meals: [],
    diet: null,
    sniadanie: [],
    IIsniadanie: [],
    obiad: [],
    przekaska: [],
    kolacja: [],
    todayDate: moment().format('YYYY-MM-DD'),

    challengeMode:
      this.props.location.state && this.props.location.state.challengeMode
        ? this.props.location.state.challengeMode
        : false,
  }
  componentDidMount = async () => {
    let date = moment()
    let todayDate = moment().format('YYYY-MM-DD')
    // await this.getUserInfo()
    await this.getUserDiet(todayDate)
    await this.getReturnedDate()
    await this.removeFilters()
  }

  getUserInfo = async () => {
    const user = await getUserData()

    this.setState({
      user: user,
    })

    if (user && user.diet_panel_access && !user.diet_panel_access) {
      this.props.history.push({
        pathname:
          this.props.location.state &&
          this.props.location.state.challengeMode &&
          this.props.location.state.challengeMode
            ? '/wyzwania'
            : '/trening',
      })
    }
  }

  changeDiet = () => {
    this.props.history.push({
      pathname: '/dieta/wybierz-diete/',
      userChangeDiet: true,
      challengeMode:
        this.props.location.state && this.props.location.state.challengeMode
          ? this.props.location.state.challengeMode
          : false,
    })
  }

  removeFilters = () => {
    cookie.remove('mealTypeFilter')
    cookie.remove('kcalFilter')
    cookie.save('userResettedFiltersOnMainPage', true)
  }

  getReturnedDate = () => {
    if (this.props.location.state && !cookie.load('userBackFromDietDate')) {
      this.setState({
        returnedDate: this.props.location.state.returnedDate,
        date: moment(this.props.location.state.returnedDate).format(
          'dddd, DD MMMM'
        ),
      })
      this.getUserDiet(this.props.location.state.returnedDate)
      cookie.save('userBackFromDietDate', true)
    } else {
      this.setState({
        returnedDate: moment().format('YYYY-MM-DD'),
        date: moment().format('dddd, DD MMMM'),
      })
      this.getUserDiet(moment().format('YYYY-MM-DD'))
    }
  }

  nextDateBalance = () => {
    let date = !this.state.returnedDate
      ? moment()
      : moment(this.state.returnedDate)
    let date2 = !this.state.returnedDate
      ? moment()
      : moment(this.state.returnedDate)
    this.setState({
      daysAdded: ++this.state.daysAdded,
    })
    let newDate = date.add(this.state.daysAdded, 'days').format('dddd, DD MMMM')
    let newDateNotFormatted = date2.add(this.state.daysAdded, 'days')

    let standardFormatDate = newDateNotFormatted.format('YYYY-MM-DD')

    this.setState({
      date: newDate,
      chosenDate: standardFormatDate,
    })
    this.getUserDiet(standardFormatDate)
  }

  prevDateBalance = () => {
    let date = !this.state.returnedDate
      ? moment()
      : moment(this.state.returnedDate)
    let date2 = !this.state.returnedDate
      ? moment()
      : moment(this.state.returnedDate)
    this.setState({
      daysAdded: --this.state.daysAdded,
    })

    let newDateNotFormatted = date2.add(this.state.daysAdded, 'days')
    let newDate = date.add(this.state.daysAdded, 'days').format('dddd, DD MMMM')
    let standardFormatDate = newDateNotFormatted.format('YYYY-MM-DD')
    this.setState({
      date: newDate,
      chosenDate: standardFormatDate,
    })

    this.getUserDiet(standardFormatDate)
  }

  getCalorieGoal = (userBalance) => {
    this.setState({
      calorieGoal: userBalance.diet.calories_goal.calorie.amount,
      fatGoal: userBalance.diet.calories_goal.calorie.fat,
      carbsGoal: userBalance.diet.calories_goal.calorie.carbs,
      proteinGoal: userBalance.diet.calories_goal.calorie.protein,
    })
  }

  getCurrentCalories = (userBalance) => {
    this.setState({
      calorieCurrent: userBalance.meals.total_kcal.amount,
      fatCurrent: userBalance.meals.total_kcal.fat,
      proteinCurrent: userBalance.meals.total_kcal.protein,
      carbsCurrent: userBalance.meals.total_kcal.carbs,
    })
  }

  getUserDiet = async (date) => {
    const userDiet = await trackPromise(hasDiet())

    if (userDiet == false) {
      this.props.history.push({
        pathname: '/dieta/wybierz-diete/',
        userChangeDiet: false,
        challengeMode:
          this.props.location.state && this.props.location.state.challengeMode
            ? this.props.location.state.challengeMode
            : false,
      })
    }
    const userBalance = await trackPromise(getUserDailyBalance(date))
    // const userHasDiet = await trackPromise(hasDiet())

    if (userBalance) {
      this.setState({
        diet: userBalance.diet,
        meals: userBalance.meals.meals,
        userPlanData: userBalance.meals,
        userDailyBalance: userBalance,
      })

      this.splitMeals(userBalance)
      this.getCalorieGoal(userBalance)
      this.getCurrentCalories(userBalance)
    }

    // const userDiet = await getUserDietData()
  }

  splitMeals = (userBalance) => {
    userBalance.meals.meals.forEach((meal) => {
      switch (meal.meal_type_name) {
        case 'Śniadanie':
          this.setState({
            sniadanie: meal.meals,
          })
          break
        case 'II śniadanie':
          this.setState({
            IIsniadanie: meal.meals,
          })
          break
        case 'Obiad':
          this.setState({
            obiad: meal.meals,
          })
          break
        case 'Przekąska':
          this.setState({
            przekaska: meal.meals,
          })
          break
        case 'Kolacja':
          this.setState({
            kolacja: meal.meals,
          })
          break
      }
    })
  }

  removeMeal = (mealId) => {
    removeSpecificMeal()
    this.getReturnedDate()
  }

  setLoader = () => {
    this.setState({
      isLoading: !this.state.isLoading,
    })
  }

  render() {
    return (
      <DietMainScreen
        userDailyBalance={this.state.userDailyBalance}
        date={this.state.date}
        nextDateBalance={this.nextDateBalance}
        prevDateBalance={this.prevDateBalance}
        meals={this.state.meals}
        sniadanie={this.state.sniadanie}
        IIsniadanie={this.state.IIsniadanie}
        obiad={this.state.obiad}
        przekaska={this.state.przekaska}
        kolacja={this.state.kolacja}
        calorieGoal={this.state.calorieGoal}
        fatGoal={this.state.fatGoal}
        carbsGoal={this.state.carbsGoal}
        proteinGoal={this.state.proteinGoal}
        calorieCurrent={this.state.calorieCurrent}
        todayDate={this.state.todayDate}
        chosenDate={this.state.chosenDate}
        removeMeal={this.removeMeal}
        diet={this.state.diet}
        changeDiet={this.changeDiet}
        userPlanData={this.state.userPlanData}
        isDemoAccount={this.state.isDemoAccount}
        challengeMode={this.state.challengeMode}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    diet: state.diet,
  }
}

// function mapDispatchToProps(dispatch) {
//   return {
//     dietActions: bindActionCreators(dietActions, dispatch),
//   }
// }

export default compose(
  withRouter,
  connect(mapStateToProps)
)(DietMainScreenContainer)
